import React from 'react';

import { remCss, scssVariables as variables } from 'src/helpers';

const BloodTubeIcon = React.memo(
  ({
    width = 21.96,
    height = 32.609,
    fill = variables['colors-mc-primary'],
    viewBox = '0 0 21.96 32.609'
  }) => (
    <svg
      id='blood-tube'
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(height)}
      viewBox={viewBox}
    >
      <g id='Group_2787' data-name='Group 2787' transform='translate(0 0)'>
        <g id='Group_2786' data-name='Group 2786'>
          <path
            id='Path_6270'
            data-name='Path 6270'
            d='M98.95,9.322a6.568,6.568,0,0,0-3.564,1.046V4.681h.938a.637.637,0,0,0,.637-.637V.637A.637.637,0,0,0,96.324,0H84.233A.637.637,0,0,0,83.6.637V4.044a.637.637,0,0,0,.637.637h.938V27.555a5.107,5.107,0,0,0,10.214,0V21.489A6.606,6.606,0,1,0,98.95,9.322Zm-12.5.258h7.667v1.456H86.445ZM84.87,1.274H95.687V3.407H84.87Zm9.242,3.407V8.306H86.445V4.681Zm0,22.874a3.834,3.834,0,0,1-7.667,0V25.617h3.461a.637.637,0,0,0,.637-.637V23.33a.637.637,0,0,0-1.274,0v1.014H86.445v-8.87h2.824v2.1a.637.637,0,0,0,1.274,0V14.837a.637.637,0,0,0-.637-.637H86.445V12.31h6.98a6.6,6.6,0,0,0,.687,8.114s0,.008,0,.012v7.119Zm4.838-6.293a5.333,5.333,0,1,1,5.333-5.333A5.339,5.339,0,0,1,98.95,21.262Z'
            transform='translate(-83.596 0)'
            fill={fill}
          />
          <path
            id='Path_6271'
            data-name='Path 6271'
            d='M279.714,186.106a.637.637,0,0,0-.876,0c-.272.258-2.661,2.578-2.661,4.684a3.1,3.1,0,1,0,6.2,0C282.374,188.69,279.986,186.364,279.714,186.106Zm-.438,6.508a1.827,1.827,0,0,1-1.825-1.825c0-1.077,1.082-2.5,1.824-3.308.742.814,1.825,2.235,1.825,3.308A1.827,1.827,0,0,1,279.276,192.614Z'
            transform='translate(-263.912 -174.089)'
            fill={fill}
          />
          <path
            id='Path_6272'
            data-name='Path 6272'
            d='M173.911,311.31a.637.637,0,1,0-.235.773A.643.643,0,0,0,173.911,311.31Z'
            transform='translate(-167.013 -291.115)'
            fill={fill}
          />
        </g>
      </g>
    </svg>
  )
);
BloodTubeIcon.displayName = 'BloodTubeIcon';

export default BloodTubeIcon;
